import React, { useState, useEffect } from 'react'
import Navbar from "../components/Layouts/Navbar";
import HeroBanner from '../components/Common/HeroBanner';
import * as Yup from 'yup';
import dynamic from 'next/dynamic'
import Head from 'next/head'
import CallBackForm from '../components/Common/CallBackForm';
import axios from 'axios'
import { GoogleMapsEmbed } from '@next/third-parties/google'
import Image from 'next/image';
const Footer = dynamic(() => import('../components/Layouts/Footer', { ssr: false }));
const Breadcrumb = dynamic(() => import('../components/Layouts/Breadcrumb', { ssr: false }));
const ContactForm = dynamic(() => import('../components/Contact/ContactForm', { ssr: false }));
const ContactInfo = dynamic(() => import('../components/Contact/ContactInfo'), { ssr: false });

const ContactUs = ({slug=null}) => {
  const [scrolled, setScrolled] = useState(0)
  const [scrolledStatus, setScrolledStatus] = useState(false)


  useEffect(() => {
    const onScroll = () => setScrolled(window.pageYOffset);
    // clean up code
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const options = {
    btn_name: "Submit"
  }
  useEffect(() => {
    if (scrolled > 30) {
      setScrolledStatus(true)
    }
  }, [scrolled])

  const phoneRegExp = /^(\+\d{1,4})?(\d{9,14})$/

  const fields = [
    {
      name: 'name',
      label: 'Name',
      validation: Yup.string().matches(/^[a-zA-Z\s]*$/, 'Name can only contain letters and spaces').required('Name is required'),
      customClass: 'md:col-span-6 col-span-12'
    },
    {
      name: 'email',
      type: 'email',
      label: 'Email',
      validation: Yup.string().email('Invalid email').required('Email is required'),
      customClass: 'md:col-span-6 col-span-12'
    },
    {
      name: 'phone',
      label: 'Phone',
      validation: Yup.string().matches(phoneRegExp, 'Phone number is not valid'),
      customClass: 'col-span-12'
    },
    {
      name: 'message',
      label: 'Message',
      type: 'textarea',
      customClass: 'col-span-12 mb-5'
    },
  ];

  return (
    <>
      <div>
        <Navbar />
        <HeroBanner
          background={process.env.IMG_CDN + 'img/pages/jpg/contact-us-banner.png'}
          title="Contact DelveInsight"
          description="We appreciate your interest in DelveInsight, and are always here to help you."
        />

        <Breadcrumb />
        <div className="w-11/12 xl:max-w-screen max-w-screen-2xl mx-auto lg:my-10 my-6">
          <div className="grid grid-cols-12 gap-4">
            <div className='md:col-span-6 col-span-12'>
              <div className="border md:px-6 px-4 rounded-md py-4 lg:py-8">
                <h2 className="text-lg font-semibold tracking-tight text-gray-900 dark:text-white sm:text-2xl">
                  WE ARE HERE TO SERVE YOU
                </h2>
                <p className="text-base  text-gray-600 dark:text-white">
                  We would be glad to hear from you. Fill the form and our team will reach out to you.
                </p>
                <CallBackForm
                  fields={fields}
                  options={options}
                  page_name="Contact Us"
                  form_name="contact-us-form"
                  endpoint='/enquiry/contact-us'
                  slug={slug}
                />
              </div>
            </div>
            <div className='md:col-span-6 col-span-12'>
              <GoogleMapsEmbed
                apiKey="AIzaSyATSXo7uwEImEMaNyvGi4OelApxNACNl1w"
                height={500}
                width="100%"
                mode="place"
                q="DelveInsight+Business+Research,+Corporate+Park,+428,+Fourth+Floor,+Sector+21,+Dwarka,+New+Delhi,+Delhi+110077"
              />
              {/* <iframe
                className='px-2 lg:px-4'
                title="Contact Us"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.3975027188058!2d77.06615751508157!3d28.587849582435425!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1b3d36a3c0d9%3A0xfab2b66e90571f12!2sDelveInsight+Business+Research!5e0!3m2!1sen!2s!4v1499573453701"
                width="100%"
                height="500"
                frameBorder="0"
                style={{
                  border: 0
                }}
                allowFullScreen>
              </iframe> */}
            </div>
          </div>
        </div>
        {scrolledStatus && <>

          <ContactInfo />
          <Footer />
        </>}
      </div>
    </>
  )
}

ContactUs.getInitialProps = async (NextPageContext) => {
  const slugData = NextPageContext.pathname
  try {
      const response = await axios.get(process.env.API_URL + '/meta' + slugData);
      return {
          title: (response?.data.meta_title) ? response?.data.meta_title : "Cart | DelveInsight",
          description: (response?.data.meta_description) ? response?.data.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
          keywords: (response?.data.meta_keywords) ? response?.data.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
      }
  } catch (error) {
      console.error('Error fetching data:', error.message);
      return {
          title: "Cart | DelveInsight",
          description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
          keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
      };
  }
}

export default ContactUs;

